class VendorPage {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.handleInitialLoad();
  }

  handleInitialLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    const vendor = urlParams.get("vendor");

    if (vendor) {
      const vendorButton = document.querySelector(`[data-vendor="${vendor}"]`);
      if (vendorButton) {
        document
          .querySelectorAll(".collection-filter-button")
          .forEach((btn) => btn.classList.remove("active"));

        vendorButton.classList.add("active");

        const searchUrl = this.buildSearchUrl(vendor);
        this.loadVendorProducts(searchUrl, vendor);
      }
    }
  }

  bindEvents() {
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("collection-filter-button")) {
        e.preventDefault();
        this.handleVendorFilter(e.target);
      }
    });

    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("load-more-button")) {
        e.preventDefault();
        this.handleLoadMore(e.target);
      }
    });
  }

  async handleVendorFilter(button) {
    const vendor = button.dataset.vendor;

    document
      .querySelectorAll(".collection-filter-button")
      .forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");

    const browserUrl = this.buildVendorUrl(vendor);
    const searchUrl = this.buildSearchUrl(vendor);

    window.history.pushState({}, "", browserUrl);

    await this.loadVendorProducts(searchUrl, vendor);
  }

  async handleLoadMore(button) {
    const currentPage = parseInt(button.dataset.currentPage);
    const totalPages = parseInt(button.dataset.totalPages);
    const nextPage = currentPage + 1;

    if (nextPage > totalPages) return;

    button.classList.add("loading");

    try {
      const currentVendor = new URLSearchParams(window.location.search).get(
        "vendor"
      );
      const searchUrl = this.buildSearchUrl(currentVendor, nextPage);

      const response = await fetch(searchUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const html = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const newProducts = tempDiv.querySelectorAll(".collection-product");
      const productGrid = document.querySelector(".collection-products__list");

      newProducts.forEach((product) => {
        productGrid.appendChild(product);
      });

      if (nextPage < totalPages) {
        button.dataset.currentPage = nextPage;
        button.classList.remove("loading");
      } else {
        button.remove();
      }
    } catch (error) {
      console.error("Error loading more products:", error);
      button.textContent = "Error - Try Again";
      button.classList.remove("loading");
    }
  }

  async loadVendorProducts(searchUrl, vendor) {
    const container = document.getElementById("vendor-products-container");
    const list = document.querySelector(".collection-products__list");
    const titleElement = document.getElementById("vendor-title");

    list.classList.add("loading");

    try {
      const response = await fetch(searchUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const html = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const searchResults =
        tempDiv.querySelector(".collection-products") ||
        tempDiv.querySelector("#vendor-products-container");

      if (searchResults) {
        container.innerHTML = searchResults.innerHTML;
      } else {
        const productCards = tempDiv.querySelectorAll(".collection-product");

        if (productCards.length > 0) {
          container.innerHTML = '<div class="collection-products__list"></div>';
          const productList = container.querySelector(
            ".collection-products__list"
          );
          productCards.forEach((card) => productList.appendChild(card));
        } else {
          container.innerHTML =
            '<div class="collection-products__list"><p>No products found for this vendor.</p></div>';
        }
      }

      if (titleElement) {
        if (vendor === "all" || !vendor) {
          titleElement.textContent = "All Vendors";
        } else {
          const decodedVendor = decodeURIComponent(vendor);
          titleElement.textContent = decodedVendor;
        }
      }

      list.classList.remove("loading");
    } catch (error) {
      console.error("Error loading vendor products:", error);
      container.innerHTML = "<p>Error loading products. Please try again.</p>";
      list.classList.remove("loading");
    }
  }

  buildVendorUrl(vendor) {
    const baseUrl = window.location.pathname;
    if (vendor === "all" || !vendor) {
      return baseUrl;
    }
    return `${baseUrl}?vendor=${encodeURIComponent(vendor)}`;
  }

  buildSearchUrl(vendor, page = 1) {
    if (vendor === "all" || !vendor) {
      return `/collections/all?section_id=main-vendor&page=${page}`;
    } else {
      const cleanVendor = vendor.replace(/®|™|©/g, "");
      return `/search?q=vendor:"${encodeURIComponent(
        cleanVendor
      )}"&section_id=main-vendor&page=${page}`;
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new VendorPage();
});

window.addEventListener("popstate", () => {
  location.reload();
});
